import { useGetAddOnsQuery } from '../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.hooks';
import { useAppSelector } from '../reducers';
import { getAddOnsFromApiNamesWithTranslations } from '../utils/addOnsUtils';
import { isValidApiName } from '../v2/utils/typeguards';
import { useGlobalLoading } from './loadingHooks';
export const useAllEligibleAddOnsWithTranslations = ({
  searchTerm = ''
} = {}) => {
  const isAppReady = useGlobalLoading();
  const {
    data: addOnsData,
    loading: addOnsLoading
  } = useGetAddOnsQuery();
  const eligibleAddOnApiNames = addOnsData === null || addOnsData === void 0 ? void 0 : addOnsData.eligibleAddOns.filter(isValidApiName);
  const {
    filteredAddOns,
    totalAddOns
  } = useAppSelector(state => {
    if (!isAppReady) {
      return {
        filteredAddOns: [],
        totalAddOns: 0
      };
    }
    return getAddOnsFromApiNamesWithTranslations(state, eligibleAddOnApiNames || [], searchTerm);
  });
  return {
    addOns: filteredAddOns,
    totalAddOns,
    loading: !isAppReady || addOnsLoading,
    loaded: isAppReady && !addOnsLoading
  };
};